import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useGetAssignmentByVideoIdQuery, useSubmitAssignmentMutation } from '../features/assignment/assignment.Api'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import swal from 'sweetalert'

export default function SubmitAssignment({ closeModal }) {
    const { videoId } = useParams()
    const { user } = useSelector(state => state.auth)
    const { isSuccess: isSuccessFetchAssignment, data: assignment } = useGetAssignmentByVideoIdQuery(videoId)
    const [submitAssignment, { isSuccess: isSuccessSubmitAssignment }] = useSubmitAssignmentMutation()

    const { name, id: student_id } = user || {}
    const [repo_link, setRepo_link] = useState("")

    useEffect(() => {
        if (isSuccessSubmitAssignment) {
            swal("Successful", "Assignment submit successful", "success");
            closeModal()
        }
    }, [isSuccessSubmitAssignment, closeModal])


    function handleSubmitAssignment(e) {
        e.preventDefault();

        if (isSuccessFetchAssignment && assignment.length > 0) {
            const { title, id: assignment_id } = assignment[0]

            submitAssignment({
                student_id,
                student_name: name,
                assignment_id,
                title,
                createdAt: moment().format(),
                totalMark: 100,
                mark: 0,
                repo_link,
                status: "pending"
            })

            e.target.reset()
        }
    }

    return (
        <div>
            <form className='py-8' onSubmit={handleSubmitAssignment}>
                <div className="mb-6">
                    <label htmlFor="repo_link" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Repository link</label>
                    <input type="url" id="repo_link" name="repo_link" value={repo_link} onChange={e => setRepo_link(e.target.value)} className="border rounded-lg  block w-full p-1 bg-gray-700 border-gray-600 placeholder-gray-400 text-white focus:ring-blue-500 focus:border-blue-500" required />
                </div>
                <button type="submit">Submit Assignment</button>
            </form>
        </div>
    )
}
